var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilterReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2499 0.332031H0.750102C0.339177 0.332031 0 0.657759 0 1.05239C0 1.44702 0.339177 1.77275 0.750102 1.77275H15.2499C15.6608 1.77275 16 1.44702 16 1.05239C16 0.657759 15.6673 0.332031 15.2499 0.332031Z",
    fill: "#CF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2375 4.27834H2.76923C2.34783 4.27834 2 4.60407 2 4.9987C2 5.39333 2.34783 5.71906 2.76923 5.71906H13.2308C13.6522 5.71906 14 5.39333 14 4.9987C14 4.60407 13.6589 4.27834 13.2375 4.27834Z",
    fill: "#CF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2124 8.22465H4.79447C4.35924 8.22465 4 8.55038 4 8.94501C4 9.33964 4.35924 9.66537 4.79447 9.66537H11.2055C11.6408 9.66537 12 9.33964 12 8.94501C12 8.55038 11.6477 8.22465 11.2124 8.22465Z",
    fill: "#CF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterReport);
export default __webpack_public_path__ + "static/media/icon-filter-report.1f063e296d2dc239ec447a36b6289e2f.svg";
export { ForwardRef as ReactComponent };